import React from 'react'
import { Row, Column, Expaned } from '@/components/layout/layout'
import classNames from 'classnames'
import { getBEMCls } from '@/utils/classname'
import Iconfont from '@/components/iconfont/iconfont'

import './form-item.scss'

interface FormItemProps {
    title: string
    inline?: boolean
    icon?: string
    right?: React.ReactDOM
    titleWidth?: number
    isRequire?: boolean
    isCenter?: boolean
    error?: string
}

const FormItem: React.FC<FormItemProps> = props => {
    const cls = (...arg: string[]) => getBEMCls('form-item', ...arg)

    const itemClass = classNames(
        {
            [`${cls('require')}`]: !!props.isRequire,
            [`${cls('inline')}`]: !!props.inline,
        },
        cls('title'),
    )

    const conClass = classNames({
        [`${cls('center')}`]: props.isCenter,
    })

    return (
        <Column
            style={{
                width: '100%',
            }}
        >
            <Row data-position-relative data-padding-h-24 data-margin-top-8 className={conClass}>
                <span
                    className={itemClass}
                    style={{
                        width: `${props.titleWidth}px`,
                    }}
                >
                    {props.title}
                </span>
                <Expaned>{props.children}</Expaned>
                {props.right}
                {props.icon && <Iconfont name={props.icon} size={20} />}
            </Row>
            {props.error && (
                <span
                    data-padding-top-8
                    className={classNames(cls('error'))}
                    style={{
                        paddingLeft: `${(props.titleWidth || 56) + 40}px`,
                    }}
                >
                    {props.error}
                </span>
            )}
        </Column>
    )
}

FormItem.defaultProps = {
    isCenter: true,
    titleWidth: 56,
}

export default FormItem
